import request from '@/utils/http'
// 记录视频点击量
export function recordPV (data) {
  return request({
    url: '/rest/house/newsCenter/visitVideo',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/recordpv/index.js